import { FC } from 'react';
import { ExclamationIcon } from '@components/common/Icons/ExclamationIcon';
import { IconProps } from '@components/common/Icons/types';

const DEFAULT_COLOR = '#D97706';

export const FurtherInformationRequiredIcon: FC<IconProps> = ({ color = DEFAULT_COLOR }) => (
  <ExclamationIcon color={color} />
);
